import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dadosTabelaDeReferencia: [],
  idHeader: null,
  RoadName: "",
  snippet: "",
  distance: 0,
  status: 'IN_PROGRESS',
  status_display: 'Em Andamento'  
};
const dadosHeader = createSlice({
  name: "dadosHeader",
  initialState,
  reducers: {
    setHeader: (state, { payload }) => {
      if (payload.dadosTabelaDeReferencia)
        state.dadosTabelaDeReferencia = payload.dadosTabelaDeReferencia;
      state.idHeader = payload.idHeader;
      state.RoadName = payload.RoadName;
      state.snippet = payload.snippet;
      state.distance = payload.distance;
      state.status = payload.status || 'IN_PROGRESS'; 
      state.status_display = payload.status_display || 'Em Andamento';
    },

    reset: (state) => (state = initialState),
  },
});
export const { setHeader, reset } = dadosHeader.actions;
export default dadosHeader.reducer;
